import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import moment from "moment";
import CalendarToolbar from "components/Calendar/CalendarToolbar";
import CalendarTableShifts from "components/Calendar/CalendarTableShifts";
import { fetchBookingCalendarByParticipants } from "store/slices/booking";

const ClientBooking = () => {
  const dispatch = useDispatch();

  const [queries, setQueries] = useState({
    startDate: moment().startOf('isoWeek').format('yyyy/MM/DD'),
    endDate: moment().endOf('isoWeek').format('yyyy/MM/DD'),
    page_number: 1,
    page_size: 10,
  });

  const [loadingPage, setLoadingPage] = useState(null);
  const [data, setData] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [totalPages, setTotalPages] = useState(0);

  const _loadData = async ({ firstWeekDay, lastWeekDay, page_number, page_size } = {}) => {
    if (loadingPage) {
      return;
    }
    const newQueries = { ...queries };
    const newSelectedWeek = { ...selectedWeek };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (firstWeekDay) {
      newSelectedWeek.firstWeekDay = firstWeekDay;
      newQueries.startDate = moment(firstWeekDay).format('yyyy/MM/DD');
    }
    if (lastWeekDay) {
      newSelectedWeek.lastWeekDay = lastWeekDay;
      newQueries.endDate = moment(lastWeekDay).format('yyyy/MM/DD');
    }
    setLoadingPage(newQueries.page_number);
    const result = await dispatch(fetchBookingCalendarByParticipants({ ...newQueries }));
    setLoadingPage(null);
    const { payload } = result;
    if (payload) {
      setSelectedWeek({ ...newSelectedWeek });
      setQueries({ ...newQueries });
      setTotalPages(payload.totalPages);
      if (payload.pageNumber === 1 ) {
        setData(payload.content);
      } else if (payload.pageNumber > queries.page_number) {
        setData([...data, ...payload.content]);
      }
      
    }
  };

  useEffect(() => {
    const firstWeekDay = moment().startOf('isoWeek');
    const lastWeekDay = moment().endOf('isoWeek'); 
    setSelectedWeek({ firstWeekDay, lastWeekDay });
    _loadData({ firstWeekDay, lastWeekDay });
  }, []);

  return (
    <div>
      {
        selectedWeek &&
        <CalendarToolbar selectedWeek={selectedWeek} loadData={_loadData} loadingPage={loadingPage}/>
      }
      {
        selectedWeek && data &&
        <CalendarTableShifts
          firstWeekDay={selectedWeek.firstWeekDay}
          dataList={data}
          loadingPage={loadingPage}
          totalPages={totalPages}
          page={queries.page_number}
          loadData={_loadData}
        />
      }
    </div>
  );
};

export default ClientBooking;
